import {
  Box,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import React from "react";
import GraphCard from "./Components/GraphCard";
import ManIcon from "@mui/icons-material/Man";
import { getColorByCount } from "../../utils/getGraphColor";
import PyramidGraph from "./Components/PyramidGraph";

const Graphs = ({ data, loading }) => {
  if (loading) {
    return (
      <>
        <Grid container sx={{ marginTop: 3 }} spacing={1}>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
        </Grid>
        <Grid container sx={{ marginTop: 1 }} spacing={1}>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
          <Grid item xl={3} lg={3} sm={6} xs={12}>
            <Skeleton variant="rectangular" height={250} />
          </Grid>
        </Grid>
      </>
    );
  }
  return (
    <>
      <Grid container sx={{ marginTop: 3 }} spacing={1}>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <PyramidGraph
            title="Occupational Incident"
            data={data?.occupationalIncident}
            colors={[
              "#dd6672",
              "#d86755",
              "#e07141",
              "#ed8b43",
              "#b79a47",
              "#78a04b",
              "#36a848",
              "#2d6833",
            ]}
            cardHeight={400}
          />
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <PyramidGraph
            title="Process Safety Incident"
            data={data?.processSafetyIncident}
            colors={["#ec3a3c", "#4949e7", "#fcbd25"]}
            baseWidth={50}
            baseHeight={50}
            fontSize={16}
            cardHeight={400}
          />
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <GraphCard
            title="Category Incident"
            data={data?.categoryIncident}
            cardHeight={400}
            type="barVerticalPercentage"
          />
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <GraphCard
            title="Incident by Regional/Subsidiaries"
            // sort data to get different color
            // data={data?.incidentByRegion?.sort(
            //   (a, b) => b.countData - a.countData
            // )}
            data={data?.incidentByRegion}
            type="barHorizontal"
            cardHeight={400}
          />
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: 1 }} spacing={1}>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <Card sx={{ paddingTop: 1 }}>
            <Typography
              sx={{
                fontSize: 17,
                textAlign: "center",
                margin: "0 8px",
              }}
            >
              Injured Person Status
            </Typography>
            <CardContent>
              <Box
                sx={{
                  height: 180,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 1,
                }}
              >
                <Grid container spacing={1}>
                  {data?.injuredPersonStatus?.length === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        flex: 1,
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <div>
                          <ManIcon
                            sx={{
                              fontSize: 70,
                              color: getColorByCount(1)[0],
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: 14,
                              textAlign: "center",
                            }}
                          >
                            {data?.injuredPersonStatus[0].groupName}
                          </Typography>
                        </div>
                        <Typography
                          sx={{
                            fontSize: 50,
                            fontWeight: "bold",
                          }}
                        >
                          {data?.injuredPersonStatus[0].countData}
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    data?.injuredPersonStatus?.map((item) => (
                      <Grid
                        item
                        xs={6}
                        key={item.id}
                        sx={{ textAlign: "center" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                          }}
                        >
                          <div>
                            <ManIcon
                              sx={{
                                fontSize: 70,
                                color: getColorByCount(
                                  data?.injuredPersonStatus?.length
                                )[item.id - 1],
                              }}
                            />
                            <Typography sx={{ fontSize: 14 }}>
                              {item.groupName}
                            </Typography>
                          </div>
                          <Typography sx={{ fontSize: 50, fontWeight: "bold" }}>
                            {item.countData}
                          </Typography>
                        </div>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <GraphCard
            title="Incident By Month"
            data={data?.incidentByMonth?.sort((a, b) => a.id - b.id)}
            type="line"
          />
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <GraphCard
            title="Investigation Status"
            type="gauge"
            gaugeValue={data?.investigationStatus}
          />
        </Grid>
        <Grid item xl={3} lg={3} sm={6} xs={12}>
          <GraphCard
            title="Incident by 12 CLSR (Top 5)"
            data={data?.incidentByClsrTopFive
              ?.sort((a, b) => b.countData - a.countData)
              .slice(0, 5)}
            type="barHorizontalPercentage"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Graphs;
